import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import ComparisonSection from './components/ComparisonSection';
import FAQSection from './components/FAQSection';
import ArticlePreview from './components/ArticlePreview';
import CTASection from './components/CTASection';

export default function Home() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'AllChinaBuy Spreadsheet',
    url: 'https://allchinabuyspreadsheet.team/',
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg',
    description: 'Discover the best AllChinaBuy Spreadsheet with trusted sellers, QC photos, buying guides, and updated product lists across 14 categories.',
    sameAs: [
      'https://kaspreadsheet.com',
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://allchinabuyspreadsheet.team/',
      },
    ],
  };

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <CategoryGrid />
        <ComparisonSection />
        <FAQSection />
        <CTASection />
        <ArticlePreview />
      </main>
      <Footer />

      {/* Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
    </>
  );
}